module.exports = __webpack_public_path__ + "img/resources.22c75ecb.png";